<template>
  <div class="nuttrema-list-item-custom" v-if="group.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ title }}</span>
    </div>
    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.region.style" :label="columns.region.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.includes.style" :label="columns.includes.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.used.style" :label="columns.used.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.type.style" :label="columns.type.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.status.style" :label="columns.status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>

        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group">

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text">
                <div class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="two-line-text__description">
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.region.style">
              <div class="two-line-text">
                <div class="two-line-text__title">
                  <span>{{ item.country }}</span>
                </div>
                <div class="two-line-text__description">
                  <span>{{ item.version }}, {{ item.year | moment('ll') }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.includes.style">
                <span v-for="item in _get(item, 'includes', [])">{{ item }}</span>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.used.style">
              {{ _get(item, 'usage.used') ? $t('label.yes') : $t('label.no') }}
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.type.style">
              <el-tooltip class="item" effect="dark" :content="_get(item, 'SourceType.name')" placement="top">
                <i :class="sourceTypeIcon(item)"></i>
              </el-tooltip>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.status.style">
              <template v-if="item.preactivated">
                 <el-tooltip class="item" effect="dark" content="Included in your subscription plan by default" placement="top-start">
                  <el-tag size="small">
                    {{ $t('label.preactivated') }}
                  </el-tag>
                </el-tooltip>
              </template>
              <el-tag v-else size="small" :type="item.active ? 'success' : 'info'">{{ _get(item, 'active') ? $t('label.active') : $t('label.inactive') }}</el-tag>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                class="el-button el-button--text"
                :to="{ name: 'instance-settings-source-details', params: { id: item.id }}">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';
import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

export default {
  name: 'cmpt-instances-sources-list-item',
  mixins: [NuttremaIndexListItem],
  props: {
    features: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaIconicaKcal,
  },
  data() {
    return {
      columns: {
        name: {
          label: 'label.name',
          style: {
            'min-width': '225px',
            'flex-basis': 'auto',
            'flex-grow': '1',
            height: '2.5em',
          },
        },
        region: {
          label: 'label.region_and_release',
          style: {
            'max-width': '200px',
            'min-width': '200px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        includes: {
          label: 'label.includes',
          style: {
            'max-width': '100px',
            'min-width': '75px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        used: {
          label: 'label.used',
          style: {
            'min-width': '35px',
            'max-width': '50px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        type: {
          label: 'label.type',
          style: {
            'min-width': '35px',
            'max-width': '35px',
            'flex-basis': 'auto',
            'flex-grow': '1',
            'justify-content': 'center',
          },
        },
        status: {
          label: 'label.status',
          style: {
            'min-width': '75px',
            'max-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
  methods: {
    sourceTypeIcon(item) {
      return get(item, 'SourceType.code') === 'premium' ? 'far fa-gem' : 'far fa-cube';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/sources/list/cmpt-instance-sources-list-item.vue